import "./ImageComponent.scss";

function ImageComponent(props){
return (
<div className="image">
                    <div className="image-component" data-disabled-mode>
                        <div className="image-wrapper">
                            <div className="amod-image-component ">
                                <picture>
                                    <source media="(max-width:568px)"
                                        src={props.src} />
                                    <img className="image "
                                        src={props.src} />
                                </picture>
                            </div>
                        </div>
                    </div>
                </div>

)}



export default ImageComponent;
